import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

export interface CompletenessStatusCardRequirementItem {
  id: string;
  met: boolean;
  text?: string | null;
  translationKey?: string | null;
  translationScope?: string | null;
  metIconClass?: string | undefined;
  unmetIconClass?: string | undefined;
}

@Component({
  selector: 'multisite-tracking-completeness-status-card',
  imports: [TranslocoModule],
  templateUrl: './tracking-completeness-status-card.component.html',
  styleUrls: ['./tracking-completeness-status-card.component.scss'],
})
export class TrackingCompletenessStatusCardComponent {
  isComplete = input<boolean>(false);

  titleText = input<string | undefined>();
  titleTranslationKey = input<string | undefined>();
  titleTranslationScope = input<string | undefined>();
  
  descriptionText = input<string | undefined>();
  descriptionTranslationKey = input<string | undefined>();
  descriptionTranslationScope = input<string | undefined>();

  completeBadgeText = input<string | undefined>();
  completeBadgeTranslationKey = input<string>('tracking.completed');
  completeBadgeTranslationScope = input<string | undefined>();

  incompleteBadgeText = input<string | undefined>();
  incompleteBadgeTranslationKey = input<string>('tracking.incomplete');
  incompleteBadgeTranslationScope = input<string | undefined>();

  requirements = input<CompletenessStatusCardRequirementItem[]>([]);

  resolveKey(translationKey?: string | null, translationScope?: string | null): string | null {
    if (!translationKey) {
      return null;
    }

    if (translationScope) {
      return `${translationScope}.${translationKey}`;
    }

    return translationKey;
  }

}
